import * as React from 'react';
import type { SVGProps } from 'react';
const SvgMeterIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <mask
      id="a"
      width={20}
      height={20}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
    >
      <path fill="#D9D9D9" d="M0 0h20v20H0z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#5C78C7"
        d="M6.334 17q-.729 0-1.344-.312-.616-.313-1.198-.959-.855-.937-1.333-2.25a7.8 7.8 0 0 1-.48-2.687q0-1.605.636-3.021.636-1.417 1.73-2.48a8.2 8.2 0 0 1 2.551-1.676A7.9 7.9 0 0 1 10 3q1.667 0 3.115.625a8.2 8.2 0 0 1 2.542 1.708 8 8 0 0 1 1.718 2.532Q18 9.313 18 10.958q0 1.48-.51 2.771a6.1 6.1 0 0 1-1.448 2.188 4.1 4.1 0 0 1-1.167.812q-.603.27-1.229.271-.354 0-.729-.094a4 4 0 0 1-.73-.26L11 16.062a2.119 2.119 0 0 0-.937-.208 2.74 2.74 0 0 0-1.23.292l-1.02.5q-.355.166-.73.26t-.75.094m0-1.48q.208 0 .406-.051.198-.053.406-.156l1-.521q.417-.23.896-.334t.98-.104q.457 0 .864.094.406.093.781.281l1.167.584q.228.104.406.156.177.052.385.052.355 0 .698-.156.344-.157.698-.49a4.24 4.24 0 0 0 1.104-1.656q.375-.99.375-2.156 0-2.75-1.885-4.657Q12.73 4.501 10 4.5q-2.707 0-4.614 1.896t-1.907 4.583q0 1.167.386 2.177.385 1.011 1.094 1.698.354.354.687.51t.688.157M10 12.25q.625 0 1.063-.437.437-.438.437-1.063 0-.166-.03-.333a1.3 1.3 0 0 0-.116-.334l1.105-1.437q.27.292.458.625.187.333.23.729a.8.8 0 0 0 .25.49.7.7 0 0 0 .5.197q.353 0 .572-.302a.8.8 0 0 0 .136-.677 4.7 4.7 0 0 0-1.657-2.666A4.54 4.54 0 0 0 10 6Q8.313 6 7.021 7.052A4.63 4.63 0 0 0 5.375 9.73a.76.76 0 0 0 .146.667.71.71 0 0 0 .583.291.7.7 0 0 0 .5-.197.8.8 0 0 0 .25-.49A2.87 2.87 0 0 1 7.96 8.188 3.26 3.26 0 0 1 10 7.5q.334 0 .646.063.313.062.604.187l-1.146 1.5H10q-.624 0-1.062.438A1.45 1.45 0 0 0 8.5 10.75q0 .624.438 1.063.437.437 1.062.437"
      />
    </g>
  </svg>
);
export default SvgMeterIcon;
